import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "./config.service";

export const InterceptorSkipHeader = "X-Skip-Interceptor";

export interface IVasRequestOptions {
    headers?: HttpHeaders;
    observe?: "body";
    params?:
        | HttpParams
        | {
              [param: string]: string | string[];
          };
    reportProgress?: boolean;
    responseType?: "json";
    withCredentials?: boolean;
    body?: any;
    skipErrorInterceptor?: boolean;
}

@Injectable({
    providedIn: "root",
})
export class VasService {
    private readonly configService = inject(ConfigService);
    private readonly httpClient = inject(HttpClient);

    private readonly apiBaseUrl: string;

    constructor() {
        this.apiBaseUrl = `${this.configService.VAS_CONTEXT_PATH}/api`;
    }

    get<T>(endPoint: string, options?: IVasRequestOptions): Observable<T> {
        if (options?.skipErrorInterceptor) {
            options.headers = new HttpHeaders().set(InterceptorSkipHeader, "");
        }

        return this.httpClient.get<T>(`${this.apiBaseUrl}${endPoint}`, options);
    }

    post<T>(
        endPoint: string,
        body?: object,
        options?: IVasRequestOptions,
    ): Observable<T> {
        if (options?.skipErrorInterceptor) {
            options.headers = new HttpHeaders().set(InterceptorSkipHeader, "");
        }

        return this.httpClient.post<T>(
            `${this.apiBaseUrl}${endPoint}`,
            body,
            options,
        );
    }

    put<T>(
        endPoint: string,
        body?: object,
        options?: IVasRequestOptions,
    ): Observable<T> {
        if (options?.skipErrorInterceptor) {
            options.headers = new HttpHeaders().set(InterceptorSkipHeader, "");
        }

        return this.httpClient.put<T>(
            `${this.apiBaseUrl}${endPoint}`,
            body,
            options,
        );
    }

    patch<T>(
        endPoint: string,
        body?: object,
        options?: IVasRequestOptions,
    ): Observable<T> {
        if (options?.skipErrorInterceptor) {
            options.headers = new HttpHeaders().set(InterceptorSkipHeader, "");
        }

        return this.httpClient.patch<T>(
            `${this.apiBaseUrl}${endPoint}`,
            body,
            options,
        );
    }

    delete<T>(endPoint: string, options?: IVasRequestOptions): Observable<T> {
        if (options?.skipErrorInterceptor) {
            options.headers = new HttpHeaders().set(InterceptorSkipHeader, "");
        }

        return this.httpClient.delete<T>(
            `${this.apiBaseUrl}${endPoint}`,
            options,
        );
    }
}

export function vasServiceCreator(): VasService {
    return new VasService();
}
